import React from 'react';
import PropTypes from 'prop-types';

import CollaboratorHeader from 'components/project/collaborator_header';
import { ProjectDatabaseMemberPropTypes } from 'components/project/prop_types';
import ProjectThumbnail from './project_thumbnail';
import StatusLabel from 'components/status_label';
import Tooltip from 'components/tooltip';
import { Col, Container, Row } from 'react-bootstrap-5';

const updatedImageStyles = {
  objectFit: 'cover',
  width: '100%',
  height: '100%'
};

const imageContainerStyle = {
  height: '88px',
  width: '183px',
  overflow: 'hidden'
};

export default function LayoutHeader({
  children,
  collaborators,
  hasDealStatusLabelDisabled,
  status,
  subtitle,
  thumbnailUrl,
  title,
  tertiaryTitle,
  onCollaboratorsUpdated,
  onUpdateNotificationsBlockedUserIds
}) {
  const tooltipText = 'This property has no sale or lease listing. Use the property edit form to setup a sale or lease \
    listing.';

  const statusLabel = () => {
    // For some reason the StatusLabel.LableWithDot component will not work with the tooltip unless the content is an
    // individual div or icon. We hard coded the child elements that we needed here for now until we can correct this
    // bug.
    if (status === 'No Listing Status') {
      return (
        <Tooltip
          content={tooltipText}
          dark
          placement="bottom"
        >
          <div className="d-flex gap-1 align-items-center">
            <span className="dot label-no-listing-status"></span>
            <span className="label-text-no-listing-status" name="label">No Listing Status</span>
          </div>
        </Tooltip>
      );
    } else {
      return <StatusLabel.LabelWithDot status={status}/>;
    }
  };

  const renderSubTitle = () => {
    if (!subtitle && !status) return;

    const subtitleClass = `text-muted d-inline-block pr-3 mr-3 mb-0 ${
      hasDealStatusLabelDisabled ? '' : 'border-right'
    }`;
    const statusText = hasDealStatusLabelDisabled ? undefined : statusLabel();
    return (
      <Row className="mt-1 fs-large text-muted fw-light">
        {subtitle && (
          <Col className={statusText ? 'border-end' : ''} xs="auto">
            <div className={subtitleClass} name="projectSubtitle">
              {subtitle}
            </div>
          </Col>
        )}
        {statusText && (
          <Col>
            <div name="projectDealStatus">{statusText}</div>
          </Col>
        )}
      </Row>
    );
  };

  return (
    <div className="bg-white shadow border-bottom">
      <Container fluid>
        <Row className="align-items-center gy-2">
          <Col className="ps-0" xs="auto">
            <ProjectThumbnail
              imageContainerStyle={imageContainerStyle}
              imageStyle={updatedImageStyles}
              noShadow
              thumbnailUrl={thumbnailUrl}
            />
          </Col>
          <Col>
            <div className="left-buffer-sm grow">
              <h6>{title}</h6>
              {renderSubTitle()}
              {tertiaryTitle}
            </div>
          </Col>
          <Col md="auto" xs={12}>
            <Row className="justify-content-between align-items-center pb-2 pb-md-0">
              <Col xs="auto">
                <CollaboratorHeader
                  collaborators={collaborators}
                  size="36px"
                  onCollaboratorsUpdated={onCollaboratorsUpdated}
                  onUpdateNotificationsBlockedUserIds={onUpdateNotificationsBlockedUserIds}
                />
              </Col>
              {children &&
                <Col xs="auto">
                  <div className="one-line">
                    {children}
                  </div>
                </Col>
              }
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

LayoutHeader.propTypes = {
  children: PropTypes.node,
  collaborators: PropTypes.arrayOf(ProjectDatabaseMemberPropTypes).isRequired,
  collaboratorsLabel: PropTypes.string,
  hasDealStatusLabelDisabled: PropTypes.bool,
  premiumListing: PropTypes.bool,
  status: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tertiaryTitle: PropTypes.node,
  thumbnailUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onCollaboratorsUpdated: PropTypes.func,
  onUpdateNotificationsBlockedUserIds: PropTypes.func
};
